import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  lang: PropTypes.string
};
function ToggleBlock(_ref) {
  var children = _ref.children,
    id = _ref.id,
    isChecked = _ref.isChecked,
    lang = _ref.lang,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "toggle-block",
    "data-testid": "toggle-block-".concat(id)
  }, /*#__PURE__*/React__default.createElement("input", {
    checked: isChecked,
    className: "toggle-radio",
    id: id,
    name: name,
    onChange: onChange,
    type: "radio",
    value: value
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "toggle-label",
    "data-testid": "toggle-label",
    htmlFor: id,
    lang: lang
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "toggle-text"
  }, children)));
}
ToggleBlock.propTypes = propTypes;

export { ToggleBlock as default };
//# sourceMappingURL=ToggleBlock.js.map
